import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import CustomFieldsEditorModal from './CustomFieldsEditorModal';

export default class CustomFieldsViewer extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.environmentExpanded = false;
    this.needsAccordion = false;
  }

  oncreate(vnode) {
    super.oncreate(vnode);
    this.checkAccordionNeeded();
  }

  onupdate(vnode) {
    super.onupdate(vnode);
    this.checkAccordionNeeded();
  }

  checkAccordionNeeded() {
    const el = this.element && this.element.querySelector('.CustomFields-collapsible');
    if (el && !this.environmentExpanded) {
      const needed = el.scrollHeight > el.clientHeight;
      if (needed !== this.needsAccordion) {
        this.needsAccordion = needed;
        m.redraw();
      }
    }
  }

  view() {
    const discussion = this.attrs.discussion;
    const definitions = this.attrs.definitions || [];
    const values = discussion.customFieldValues() || {};

    const hasAnyValue = definitions.some(
      (field) => values[field.key] && values[field.key].trim()
    );
    const canEdit = discussion.canEditCustomFields();

    if (!hasAnyValue && !canEdit) return <div />;

    const viewerClass = 'CustomFields-viewer' + (hasAnyValue ? '' : ' CustomFields-viewer--empty');

    return (
      <div className={viewerClass}>
        {canEdit && (
          <Button
            className="Button CustomFields-editButton"
            icon="fas fa-pen"
            onclick={() =>
              app.modal.show(CustomFieldsEditorModal, { discussion })
            }
          >
            {app.translator.trans(
              'butterflycode-custom-fields.forum.edit_fields_button'
            )}
          </Button>
        )}

        {definitions.map((field) => {
          const value = values[field.key];
          if (!value || !value.trim()) return <div key={field.key} />;

          if (field.key === 'environment') {
            return this.renderEnvironmentField(field, value);
          }

          return (
            <div key={field.key} className="CustomFields-fieldDisplay Form-group">
              <label className="CustomFields-label">
                {field.key === 'url' && <i className="fas fa-link" />}
                {' '}{field.label}
              </label>
              <div className={"FormControl CustomFields-value" + (field.key === 'url' ? ' CustomFields-value--url' : '')}>
                {field.type === 'textarea' ? (
                  <pre className="CustomFields-preformatted">{value}</pre>
                ) : (
                  value
                )}
                {field.key === 'url' && value && /^https?:\/\//i.test(value) && (
                  <a
                    className="CustomFields-externalLink"
                    href={value}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={value}
                  >
                    <i className="fas fa-external-link-alt" />
                  </a>
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  renderEnvironmentField(field, value) {
    const expanded = this.environmentExpanded;
    const collapsibleClass = 'CustomFields-collapsible' + (expanded ? ' is-expanded' : '');

    return (
      <div key={field.key} className="CustomFields-fieldDisplay Form-group">
        <label className="CustomFields-label">
          <i className="fas fa-server" />
          {' '}{field.label}
        </label>
        <div className="FormControl CustomFields-value CustomFields-value--environment">
          <div className={collapsibleClass}>
            <pre className="CustomFields-preformatted">{value}</pre>
          </div>
        </div>
        {(this.needsAccordion || expanded) && (
          <button
            className="CustomFields-toggleButton"
            onclick={(e) => {
              e.preventDefault();
              this.environmentExpanded = !this.environmentExpanded;
              if (!this.environmentExpanded) {
                this.needsAccordion = true;
              }
            }}
          >
            {expanded
              ? app.translator.trans('butterflycode-custom-fields.forum.collapse_environment')
              : app.translator.trans('butterflycode-custom-fields.forum.expand_environment')}
          </button>
        )}
      </div>
    );
  }
}
